export const API_KEY = 'apiKey';
export const GENERAL = 'general';
